//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PersonalCard',
  props: {
    title: { type: String, default: '' },
    padding: { type: Boolean, default: false },
    lecturer: { type: Boolean, default: false },
    owner: { type: Boolean, default: false },
  },
};
